import Marquee from "react-fast-marquee";
import React, { useState, useEffect } from "react";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Toast } from "../../../CustomComponent/toast";
const getTaskListDetails = (task = []) => {
  let totalTasks = task.length;
  let completedTasks = task?.filter((t) => t.isUpdated || t.isNotApplicable);
  if (completedTasks.length == totalTasks) {
    return `Completed: (${completedTasks.length}/${totalTasks})`;
  }
  return `Started: (${completedTasks.length}/${totalTasks})`;
};

const getProjectDate = (item) => {
  if (item.taskList) {
    return `${getTaskListDetails(item?.taskList)}`;
  } else {
    return item?.newSiteInspection?.tentativeStartDate || "N/A";
  }
};
function MarqueeScroll({ direction }) {
  const [projectTrackingData, setProjectTrackingData] = useState();
  useEffect(() => {
    performRequest("GET", "/projectTracking/getAllProjectTracking")
      .then((res) => {
        if (res.status === 200) {
          let data = res.data?.projectTrackingData.filter((project) =>
            project.taskList.some(
              (task) =>
                (task?.taskName === "Project Handover" ||
                  task?.taskName === "Handover") &&
                task?.isUpdated !== true &&
                task?.isLocked !== true
            )
          );
          setProjectTrackingData(data);
        } else {
          Toast("error", "Error while getting project Details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  return (
    <>
      <div style={{ display: "flex", overflow: "hidden" }}>
        <Marquee
          direction={`${direction}`}
          style={{
            display: "flex",
            width: "100%",
          }}
          gradient={false}
          loop={0}
          autoFill={true}
          speed={60}
        >
          {projectTrackingData?.map((item, index) => (
            <div key={index}>
              <div
                className="border m-1"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "5px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  marginBottom: "5px",
                  width: "250px",
                  height: "100px",
                  borderRadius: "15px",
                  background: "rgb(192,230,255)",
                  background:
                    "linear-gradient(153deg, rgba(192,230,255,1) 0%, rgba(249,254,255,1) 100%)",
                  boxShadow:
                    "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)",
                }}
              >
                <p
                  style={{
                    fontSize: "22px",
                    marginLeft: "8px",
                    marginTop: "8px",
                    fontWeight: "500",
                  }}
                >
                  {item?.projectClientName || item?.siteClientName || "N/A"}{" "}
                  <br />
                  {getProjectDate(item)}
                </p>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </>
  );
}

export default MarqueeScroll;
